import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore'

const DEFAULT_ITEM_PER_PAGE = 20
class PrintPurchaseReceivedDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      report_title:'กำลังดึงข้อมูล..',
      itemPerPage:DEFAULT_ITEM_PER_PAGE,
      allData: [],
      data: {
        company_addr:'',
        company_fax:'',
        company_name:'',
        company_branch:'',
        company_tel:'',
        item:[],
        logo_class:'',
        logo_height:'',
        logo_url:'',
        logo_width:'',
        meta:{},
        org_id:'',
        doclist:{
          meta:{},
          item:[]
        }
      }
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData(this.state.itemPerPage)
  }

  loadData(itemPerPage) {
    let {allData,data} = this.state
    if (this.props.recordType==='RECEIVED') {
      PdfStore.loadPOReceivedDoc(this.props.poNo,(result)=> {
        if (result.data!==undefined)
          data = result.data

        allData = this.getPagination(data,itemPerPage)
        this.setState({data:data,allData:allData,report_title:'ไม่พบข้อมูล'})
      })
    } else if (this.props.recordType==='EXPORTWORK') {
      PdfStore.loadPOExportWorkDoc(this.props.poNo,(result)=> {
        if (result.data!==undefined)
          data = result.data

        allData = this.getPagination(data,itemPerPage)
        this.setState({data:data,allData:allData,report_title:'ไม่พบข้อมูล'})
      })
    } else if (this.props.recordType==='RETURN') {
      PdfStore.loadPOReturnDoc(this.props.poNo,(result)=> {
        if (result.data!==undefined)
          data = result.data

        allData = this.getPagination(data,itemPerPage)
        this.setState({data:data,allData:allData,report_title:'ไม่พบข้อมูล'})
      })
    } else if (this.props.recordType==='IMPORT_STOCK') {
      PdfStore.loadPOImportStockDoc(this.props.poNo,(result)=> {
        if (result.data!==undefined)
          data = result.data

        allData = this.getPagination(data,itemPerPage)
        this.setState({data:data,allData:allData,report_title:'ไม่พบข้อมูล'})
      })
    }  
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderRowData(items,page=0) {
    if (items.data.length===0||items.data===undefined) {
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        items.data.map((item,index) => {
          let number = 0
          if (page===0)
            number = parseInt(index)+parseInt(1)
          else
            number = parseInt((page*this.state.itemPerPage)) + parseInt(index)+parseInt(1)
          
          return(
            <tr key={index} className={index>0?'n-b':''}>
              <td className='text-center'>{number}</td>
              <td className='text-center'>{item.productcode}</td>
              <td>{item.detail}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-right'>{item.price_per_unit}</td>
              <td className='text-right'>{item.amount}</td>
            </tr>
          )
        })
      )
    }
  }

  renderFooter() {
    let {data} = this.state
    let sum = 0,sumAmount=0
    data.item.forEach(function(item,index) {
      let quantity = item.quantity  
      if (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)) {
        quantity = 0
      }
      sum += parseFloat(quantity)
      sumAmount += parseFloat(item.amount)
    })
    return(
      <tr>
        <td colSpan={3}>รวมรายการ</td>
        <td className='text-center'>{sum}</td>
        <td className='text-center'>-</td>
        <td className='text-right'>{sumAmount}</td>
      </tr>
    )
  }

  renderSignature() {
    return(
      <table className='table table-header-print-po-received-doc'>
        <tbody>
          <tr>
            <td className='text-center' style={{width:'50%'}}>..................................................................</td>
            <td className='text-center' style={{width:'50%'}}>..................................................................</td>
          </tr>
          <tr>
            <td className='text-center' style={{width:'50%'}}>{this.props.recordType==='RETURN'?'ลงชื่อผู้คืนสินค้า':'ลงชื่อผู้รับสินค้า'}</td>
            <td className='text-center' style={{width:'50%'}}>ผู้อนุมัติ</td>
          </tr>
          <tr>
            <td className='text-center' style={{width:'50%'}}>วันที่ ............./....................../........................</td>
            <td className='text-center' style={{width:'50%'}}>วันที่ ............/...................../...........................</td>
          </tr>
        </tbody>
      </table>    
    )
  }

  renderTable(item,index,length) {
     return(
      <div className=''>
        <table className='table table-print-po-received-doc'>
          <tbody>
            <tr>
              <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
              <td className='text-center' style={{width:'100px'}}>รหัสสินค้า</td>
              <td className='text-center' style={{width:'300px'}}>รายการ</td>
              <td className='text-center' style={{width:'70px'}}>จำนวน</td>
              <td className='text-center' style={{width:'70px'}}>ราคาต่อหน่วย</td>
              <td className='text-center' style={{width:'70px'}}>จำนวนเงิน</td>
            </tr>
            {this.renderRowData(item,index)}
            {item.footer===true?this.renderFooter():''}
          </tbody>  
        </table>
        <div className='footer-page'>
          {item.footer===true?this.renderSignature():''}
        </div>  
      </div>
    )      
  }

  renderHeader(item) {
    return(
      <div>
          <table className='table table-header-print-po-received-doc'>
            <tbody>
              <tr>
                <td style={{width:'100px'}}>เลขที่ใบสั่งซื้อ :</td>
                <td>{this.props.poNo}</td>
                <td className='text-right'>วันที่ :</td>
                <td style={{width:'120px'}} className='text-right'>{item.added_date}</td>
              </tr>
              <tr>
                <td>ผู้รับสินค้า :</td>
                <td>{item.request_by}</td>
                <td className='text-right'>ผู้อนุมัติ :</td>
                <td className='text-right'>{item.response_by}</td>
              </tr>
              <tr>
                <td>ชื่อร้าน :</td>
                <td>{this.props.shop===''||this.props.shop==='null'||this.props.shop===undefined?'':this.props.shop}</td>
                <td className='text-right'>ทะเบียนรถ :</td>
                <td className='text-right'>{this.props.car_registration===''||this.props.car_registration==='null'||this.props.car_registration===undefined?'':this.props.car_registration}</td>
              </tr>
              {this.props.recordType==='RECEIVED'?
              <tr>
                <td>เลขที่ใบส่งของ :</td>
                <td>{item.deliveryslip_no}</td>
                <td className='text-right'>เลขที่ใบกำกับ :</td>
                <td className='text-right'>{item.taxinvoice_no}</td>
              </tr>
              :''}
              <tr>
                <td>คำอธิบาย :</td>
                <td>{item.description}</td>
              </tr>
            </tbody>
          </table>
      </div>
    )
  }

  renderComponentPage(item,index,length) {
    let {data} = this.state
    const title = this.props.recordType==='IMPORT_STOCK'?'ใบนำสินค้าเข้าคลัง':this.props.recordType==='EXPORTWORK'?'ใบเบิกไปซ่อม':this.props.recordType==='RETURN'?'ใบคืนสินค้า':this.props.title
    return(
      <div className='font-print' key={index}>
        <div style={{display:(item.meta?'':'none')}}>
          <header>
            <h2>{title}</h2>
          </header>
          <article className={"article-company "+data.logo_class}>
            <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
              {this.renderLogoUrl(data.logo_url)}
            </div>
            <section className="font-18" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
            </strong>
          </section>
          </article>
        </div>
        <div>
          {item.meta?this.renderHeader(item.meta_data):''}
          {this.renderTable(item,index,length)}
        </div>
      </div>  
    )
  }

  getPagination(data,itemPerPage) {
    let checkRow = 0
    let newData = []
    let allData = []
    let meta_data = {}
    let meta = false
    let footer = false

    data.doclist.forEach(function(items,indexs) {
      items.item.forEach(function(item,index) { 
        
        if (index===0||index===itemPerPage-1) {
          meta_data = items.meta
          meta = true
          footer = false
        }

        if (checkRow<itemPerPage) {
          newData.push(item)
        }
        if (checkRow===itemPerPage-1||index===items.item.length-1) {
          if (index===items.item.length-1) {
            footer = true
          }

          allData.push({
            meta_data:meta_data,
            meta:meta,
            data:newData,
            footer:footer
          })
          meta_data = {}
          meta = false
          footer = false
          newData = []
          checkRow = -1
        }
        checkRow++
      })
    })  
    return allData
  }

  onRowsPerPageChange(itemPerPage) {
    this.setState({itemPerPage:itemPerPage})
    this.loadData(itemPerPage)
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,allData} = this.state
    let i = 0
    if (allData.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={(this.props.recordType==='EXPORTWORK'?'ใบเบิกไปซ่อม':this.props.recordType==='RETURN'?'ใบคืนสินค้า':this.props.title)+' '+this.props.poNo}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={(this.props.recordType==='EXPORTWORK'?'ใบเบิกไปซ่อม':this.props.recordType==='RETURN'?'ใบคืนสินค้า':this.props.title)+' '+this.props.poNo}
          defaultRowPerPage={DEFAULT_ITEM_PER_PAGE}
          startRowPerPage={10}
          endRowPerPage={20}
          onRowsPerPageChange={this.onRowsPerPageChange.bind(this)}
        >
          {
            allData.map((item,index) => {
              if (item.meta)
                i = 0
              else 
                i++

              return(
                this.renderComponentPage(item,i,allData.length-1)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintPurchaseReceivedDoc.defaultProps = {
  title: 'ใบรับสินค้า',  
  mode : '1'
}
export default PrintPurchaseReceivedDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintPurchaseReceivedDoc.js